import React from 'react'
import { BooleanInput, SelectInput, Labeled } from 'react-admin'
import { ProfessionalSection } from 'services/api/entities/catalog/sections/professionalSections'
import { EnrichedProfessionalService } from 'services/api/entities/events/types/internal/services'
import { professionalOutfitChoices } from 'services/cfg/form'
import SupplierSelectInput from 'ui-shared/CustomInputs/SupplierSelectInput'
import CustomizationInput from 'ui-shared/FormComponents/CustomizationInput'
import EventServiceBriefSection from 'ui-shared/FormComponents/EventServiceBriefSection'
import { SelectionDetailsProps } from 'ui-shared/FormComponents/MainProductSelectionInputContent'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import KRichTextInput from 'ui-shared/WrappedInputs/KRichTextInput'
import ProfessionalFigureArrayInput from './ProfessionalFigureArrayInput'

type Props = SelectionDetailsProps<
  ProfessionalSection,
  EnrichedProfessionalService
>

const ProfessionalsSelectionDetailsForm: React.FC<Props> = ({
  scopedFormData,
  getSource,
  selectedProduct: selectedProfessionalSection,
  isObsolete,
}) => {
  if (!scopedFormData || !getSource) return null

  const { briefQuestions, briefConfirmed } = scopedFormData

  return (
    <>
      <KRichTextInput source={getSource('notes')} label="form.fields.notes" />

      <SupplierSelectInput source={getSource(`supplier`)} />
      <BooleanInput
        label="Trigger Supplier Email"
        source={getSource(`triggerAssignmentEmail`)}
      />
      <BooleanInput
        label={
          !!scopedFormData.supplyConfirmed
            ? 'Supply confirmed'
            : 'Supply not yet confirmed'
        }
        source={`supplyConfirmed`}
        disabled
      />
      {!!scopedFormData.supplier && (
        <KRichTextInput
          source={getSource(`lastMessage`)}
          label="Last supplier message"
        />
      )}
      <BooleanInput
        label={
          !!scopedFormData.lastMessageConfirmed
            ? 'Last message confirmed'
            : 'Last message not yet confirmed'
        }
        source={getSource!(`supplyConfirmed`)}
        disabled
      />

      {!![
        selectedProfessionalSection?.specialType,
        scopedFormData.specialType,
      ].includes('waitingStaff') && (
        <SelectInput
          source="professionalOutfit"
          label="Professional Outfit"
          choices={professionalOutfitChoices}
          defaultValue={professionalOutfitChoices[0].id}
          fullWidth
          disabled={isObsolete}
        />
      )}

      <ProfessionalFigureArrayInput
        professionals={selectedProfessionalSection?.productsFull ?? []}
        isObsolete={!!isObsolete}
        scopedFormData={scopedFormData}
        getSource={getSource}
      />

      <CustomizationInput
        source={getSource!('customization')}
        customization={scopedFormData.customization}
      />

      {!!briefQuestions?.length && (
        <>
          <Kdivider title="Event Brief" headingLevel="h3" />
          <Labeled label="form.fields.briefConfirmation">
            <BooleanInput
              source={getSource!('briefConfirmed')}
              label={briefConfirmed ? 'Yes' : 'No'}
              disabled
            />
          </Labeled>
          <EventServiceBriefSection serviceSource={getSource!('')} />
        </>
      )}
    </>
  )
}

export default ProfessionalsSelectionDetailsForm
